import { useEffect, useState } from "react";
import { useProfileStore, getFacilityKeyForPortal } from "@/store/profile";
import authRequest from "@/api/auth-request";
import { PaymentCardList } from "./PaymentCardList";
import { PaymentForm } from "./PaymentForm";

type PaymentView = "PaymentCardList" | "PaymentForm";

export function PaymentInfo() {
  const currentPatient = useProfileStore((s) => s.currentPatient);
  const facilityInfo = useProfileStore((s) => s.facilityInfo);
  const currentProfilePaymentView = useProfileStore((s) => s.currentProfilePaymentView);
  const setProfilePaymentCurrentPage = useProfileStore((s) => s.setProfilePaymentCurrentPage);
  const setFacilityInfo = useProfileStore((s) => s.setFacilityInfo);
  const [view, setView] = useState<PaymentView>(currentProfilePaymentView as PaymentView);

  useEffect(() => {
    setProfilePaymentCurrentPage("PaymentCardList");
    setView("PaymentCardList");
    const key = getFacilityKeyForPortal();
    if (!key) return;
    authRequest.request
      .getFacilityInfo(key)
      .then((res) => setFacilityInfo(res.data ?? null))
      .catch(console.error);
  }, [currentPatient?.facilityID, setProfilePaymentCurrentPage, setFacilityInfo]);

  const showAddNew = facilityInfo && !facilityInfo.fortis;
  const isList = view === "PaymentCardList";

  const goToList = () => {
    setView("PaymentCardList");
    setProfilePaymentCurrentPage("PaymentCardList");
  };

  const goToForm = () => {
    setView("PaymentForm");
    setProfilePaymentCurrentPage("PaymentForm");
  };

  return (
    <div className="mx-1">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          {isList ? (
            <h3 className="text-lg font-semibold">Payment Information</h3>
          ) : (
            <button
              type="button"
              className="text-primary hover:underline"
              onClick={goToList}
            >
              <i className="fas fa-angle-left mr-1" />
              Back to Payment Information
            </button>
          )}
        </div>
        {showAddNew && isList && (
          <div className="hidden md:block">
            <button
              type="button"
              className="btn btn-primary w-40 rounded bg-primary px-4 py-2 text-primary-foreground"
              onClick={goToForm}
            >
              ADD NEW
            </button>
          </div>
        )}
      </div>
      <br />
      <div>
        {isList ? <PaymentCardList /> : <PaymentForm />}
      </div>
      <br />
      {showAddNew && isList && (
        <div className="md:hidden">
          <button
            type="button"
            className="btn btn-primary w-full rounded bg-primary py-2 text-primary-foreground"
            onClick={goToForm}
          >
            ADD NEW
          </button>
        </div>
      )}
    </div>
  );
}
